function countTestimonialsModuleHeight() {

	if(document.querySelector('.testimonials-left')) {

		var testimonialsInLeftHeight = document.querySelector('.testimonials-left').offsetHeight,
			$testimonialsHld = document.querySelector('.testimonials-content-hld-inner'),
			$html = document.getElementsByTagName('html')[0];

		if($html.hasClass('no-touchevents') && testimonialsInLeftHeight > $testimonialsHld.offsetHeight) {
			$testimonialsHld.style.height = testimonialsInLeftHeight - 10 + 'px';
		}

	}
	
};

module.exports = countTestimonialsModuleHeight;